type MoneyLike = number | string | null | undefined;

export const parseMoney = (value: MoneyLike): number => {
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  if (typeof value !== 'string') return 0;

  let s = value.trim();
  if (!s) return 0;

  s = s.replace(/[R$\s]/g, '');

  if (/,/g.test(s)) {
    s = s.replace(/\./g, '');

    s = s.replace(/,/g, '.');
  }

  const n = Number(s);
  return Number.isFinite(n) ? n : 0;
};

export const round2 = (n: number): number =>
  Math.round((n + Number.EPSILON) * 100) / 100;
